import React from 'react';
import PropTypes from 'prop-types';
import { Button, Box, ListItem, Typography } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Checkbox from '../checkbox';
import HeaderSortable from '../common/header-sortable';
import { useTranslate } from 'react-admin';
import bin from '../assets/icons/white-bin.png';

const useStyles = makeStyles(theme => ({
    header: {
        display: 'flex',
        flexDirection: 'row',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: 0,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        height:50
    },
    checkbox: {
        color: theme.palette.common.white
    },
    delete: {
        fontSize: 13,
        fontFamily: 'UniviaPro',
        fontWeight: 'normal',
        letterSpacing: '0.13px',
        lineHeight: '16.3px',
    }
}));

const StyledButton = withStyles(theme => ({
    root: {
        background: 'transparent',
        color: 'white',
        marginRight: theme.spacing(4),
    },
    label: {
        fontSize: 14,
        textTransform: 'capitalize',
        fontWeight: 'normal',
        marginLeft: theme.spacing(1)
    },
}))(Button);

function TableTemplateHeaders({ showSelectedHeader, onDelete, onCheckAll, order, onChangeSortable, checkall, isDelete }) {
    const classes = useStyles();
    const translate = useTranslate();
    const confirmDelete = () => {
        const ids = showSelectedHeader.map(item => item.id);
        onDelete(ids);
    }
    if (showSelectedHeader.length !== 0) {
        return (
            <Box mt={1} px={1} py={1} bgcolor='#56657f'>
                {
                    isDelete &&
                    <Checkbox className={classes.checkbox} checked={checkall} onClick={onCheckAll} />
                }
                <StyledButton
                    onClick={confirmDelete}
                    variant='text'
                    startIcon={<img alt='' src={bin} style={{ width: "20px", paddingRight: 5 }} />}
                    size='large'
                ><Typography className={classes.delete}>{translate('pos.common.delete')}</Typography></StyledButton>
            </Box>
        )
    }
    return (
        <ListItem className={classes.header}>
            <Box flex={0.5} px={1}>
                {
                    isDelete &&
                    <Checkbox className={classes.checkbox} onClick={onCheckAll} />
                }
            </Box>
            <Box flex={2}>
                <HeaderSortable title={translate(`pos.dashboard.name`)} field="name" order={order} setOrder={onChangeSortable} />
            </Box>
            <Box flex={3}>
                <HeaderSortable title={translate(`pos.messages.subject`)} field="subject" order={order} setOrder={onChangeSortable} />
            </Box>
            <Box flex={4}>
                <HeaderSortable title={translate(`pos.messages.message`)} field="message" order={order} setOrder={onChangeSortable} />
            </Box>
            <Box flex={1}>
                <HeaderSortable title={translate(`resources.messages.priority`)} field="priorityType" order={order} setOrder={onChangeSortable} />
            </Box>
            <Box flex={1}>
                <HeaderSortable title={translate(`pos.messages.dyslexie`)} field="dyslexie" order={order} setOrder={onChangeSortable} />
            </Box>
            <Box flex={0.5} />
        </ListItem>
    );
}

TableTemplateHeaders.propTypes = {
    showSelectedHeader: PropTypes.bool.isRequired,
    order: PropTypes.object.isRequired,
    onDelete: PropTypes.func.isRequired,
    onCheckAll: PropTypes.func.isRequired,
    onChangeSortable: PropTypes.func.isRequired
};

export default TableTemplateHeaders;
